module.exports = __webpack_public_path__ + "static/media/github.9012b97e.png";